import { PAGE_POSITIONS } from 'types';
import type { HeaderCarousel } from 'types/capi/modules';

import type { SplashSlideModuleType } from '~/events/SplashSlideInteractionEvent';

import Carousel from './Carousel';
import Slide from './Slide';

export type Variant = 'hero' | 'banner';

export type Analytics = {
  id: 'HOMEPAGE_CAROUSEL' | 'PLP_CAROUSEL';
  position: PAGE_POSITIONS;
};

// `moduleType` names the render site a slide click is an ordinal within, `modulePosition` the
// module's slot on the homepage; the PLP banner slots are not a sequence and pass none.
type Props = {
  analytics: Analytics;
  isFullBleed?: boolean;
  module: HeaderCarousel;
  modulePosition?: number;
  moduleType: SplashSlideModuleType;
  variant: Variant;
};

export default function HeaderCarousel({
  isFullBleed = true,
  module,
  modulePosition,
  moduleType,
  variant = 'hero',
  analytics
}: Props) {
  return module.items.length === 1 ? (
    <div className="flex overflow-hidden">
      <Slide
        variant={variant}
        analytics={analytics}
        slide={module.items[0]!}
        index={0}
        isFullBleed={isFullBleed}
        modulePosition={modulePosition}
        moduleType={moduleType}
      />
    </div>
  ) : (
    <Carousel
      analytics={analytics}
      variant={variant}
      module={module}
      isFullBleed={isFullBleed}
      modulePosition={modulePosition}
      moduleType={moduleType}
    />
  );
}
